import classNames from 'classnames';
import React, { createRef, Component } from 'react';
import styles from './button.module.scss';


interface ButtonProps {
	value: string
	onClick?: (event:React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
	mode?: string
	type?: 'button' | 'submit'
	id?: string;
  modifications?: {
    form: string;
    size: string;
    animation: string;
  }
  hidden?: boolean;
  counter?: boolean;
  progress?: number;
  disabled?: boolean;
};

interface State {
  styleClasses: string[];
  mode: string;
}

export default class Button extends Component<ButtonProps, State> {
  constructor(props: ButtonProps) {
    super(props);

    const mode = this.props.mode || "default";

    this.state = {
      mode: mode,
      styleClasses: [styles[mode]]
    }
  }

	buttonRef:React.RefObject<HTMLButtonElement> = createRef();
	
	setFocus = () => {
		this.buttonRef.current?.focus();
	};

	click = () => {
		this.buttonRef.current?.click();
	};

  componentDidMount() {
    const { form, size, animation } = this.props.modifications || {};
  
    if (form != "DEFAULT" || size != "DEFAULT" || animation != "DEFAULT") {
      this.setState(state => ({ 
        styleClasses: [...state.styleClasses, styles[form || ""], styles[size || ""], styles[animation || ""]]
      }))
    }

    if (this.props.hidden) {
      this.setState(state => ({
        styleClasses: [...state.styleClasses, styles["hidden"]]
      }));
    }
  }

  componentDidUpdate(prevProps: ButtonProps) {
    if (
      prevProps.modifications?.form !== this.props.modifications?.form ||
      prevProps.modifications?.size !== this.props.modifications?.size ||
      prevProps.modifications?.animation !== this.props.modifications?.animation
    ) {

      const { form, size, animation } = this.props.modifications || {};
  
      if (form != "DEFAULT" || size != "DEFAULT" || animation != "DEFAULT") {
        this.setState(state => ({ 
          styleClasses: [...state.styleClasses, styles[form || ""], styles[size || ""], styles[animation || ""]]
        }))
      }
    }

    if (prevProps.hidden !== this.props.hidden) {
      this.setState(state => ({
        styleClasses: [...state.styleClasses, (this.props.hidden ? "hidden" : "")]
      }));
    }

  }

	render() {
		const { value, onClick, type = 'button', id = '', counter, progress } = this.props;
		return (
			<button 
				id={id}
				ref={this.buttonRef} 
				className={classNames(this.state.styleClasses)} 
				onClick={onClick} 
				type={type}
        disabled={this.props.disabled}
			>
				{value}
        {counter && <span className={styles["counter"]}>Вопросов осталось: {progress}</span>}
			</button>
		);		
	}
}